import { DateTime } from "luxon";

export function calcAge(birthdate: DateTime, today: DateTime): number {
  const years = today.diff(birthdate, "years").years;
  const result = Math.floor(years);
  return result;
}
